import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiErrorDetail } from "@/lib/apiClient";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const FIELDS = [
  ["name", "Institute name"], ["legal_name", "Legal name"], ["email", "Email"],
  ["phone", "Phone"], ["website", "Website"], ["gstin", "GSTIN"],
  ["address", "Address"], ["city", "City"], ["state", "State"],
];

export default function InstituteTab() {
  const { hasPermission } = useAuth();
  const canManage = hasPermission("settings.manage");
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then(({ data }) => setForm(data?.institute_profile || {}));
  }, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings/institute_profile", { data: form });
      toast.success("Institute settings saved");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="institute-tab">
      <div className="mb-4">
        <h3 className="font-display text-lg font-semibold text-secondary">Institute profile</h3>
        <p className="text-sm text-muted-foreground">Details used across receipts and documents.</p>
      </div>
      <div className="grid grid-cols-1 gap-4 rounded-xl border border-border bg-card p-6 sm:grid-cols-2">
        {FIELDS.map(([k, label]) => (
          <div key={k} className={k === "address" ? "sm:col-span-2" : ""}>
            <Label>{label}</Label>
            <Input value={form[k] || ""} onChange={set(k)} disabled={!canManage} data-testid={`institute-${k}`} />
          </div>
        ))}
      </div>
      {canManage && (
        <div className="mt-4 flex justify-end">
          <Button onClick={save} disabled={saving} data-testid="save-institute-button">{saving ? "Saving..." : "Save changes"}</Button>
        </div>
      )}
    </div>
  );
}
